import React from 'react';
import { useTranslation } from 'react-i18next';
import Input from '../atoms/Input';
import SearchIcon from '../../assets/icons/SearchIcon';
import { setFilters, useDispute } from '../../store/slices/disputeSlice';
import { useDispatch } from 'react-redux';
import { useGetDisputeReasonsQuery } from '../../store/services/disputeService';
import FiltersPopup from './FiltersPopup';
import Button from '../atoms/Button';
import { setModalId } from '../../store/slices/publicSlice';

const Filters = () => {
  const { t } = useTranslation();
  const { search } = useDispute();
  const dispatch = useDispatch();

  return (
    <div>
      <div className="flex items-center gap-x-4">
        <Input
          id="test"
          name="test"
          value={search as string}
          onChange={(element) => {
            const newValue = element?.currentTarget?.value;
            dispatch(
              setFilters({
                search: newValue,
                page: 0,
              })
            );
          }}
          prefix={<SearchIcon />}
          placeholder={t('dispute.searchPlaceholder')}
          className="h-[47px]"
        />

        <Button
          variant="outline"
          onClick={() => dispatch(setModalId({ id: 'DISPUTE_FILTERS' }))}
          size="md"
        >
          Filters
        </Button>
      </div>

      <FiltersPopup />
    </div>
  );
};

export default Filters;
